import { reactive } from 'vue';

export const store = reactive({
 // Auth state
 user: null,
 isAuthenticated: false,
 loading: true,
 pendingAction: null,
 showAuthModal: false,
 showSignInModal: false,
 showCharmModal: false,

 // Cart state 
 carts: JSON.parse(localStorage.getItem('carts') || '[]'),

 init() {
   this.loadCartsFromLocal();
   this.user = JSON.parse(localStorage.getItem('user'));
   this.isAuthenticated = !!this.user; //?????
   this.loading = false;
 },

 // Auth methods
 async requireAuth(pendingAction) {
   if (this.isAuthenticated) return true;
   this.pendingAction = pendingAction;
   this.showAuthModal = true;
   return false;
 },

 setUser(userData) {
   this.user = userData;
   this.isAuthenticated = !!userData;
   localStorage.setItem('user', JSON.stringify(userData));
   
   if (this.pendingAction) {
     this.pendingAction();
     this.pendingAction = null;
   }
 },

 logout() {
   this.user = null;
   this.isAuthenticated = false;
   localStorage.removeItem('user');
 },

 // Cart methods
 async addToCart(product, selectedOptions = null) {
  console.log('🛒 Adding to cart:', product, selectedOptions ? 'with options:' : '', selectedOptions);
  
  const venueId = product.venue?.id;
  let cart = this.carts.find(c => c.venueId === venueId);
  
  if (!cart) {
    cart = {
      venueId,
      venueName: product.venue?.name || '',
      organization_id: product.venue?.organization_id || '',
      items: [],
      total: 0,
      tax: 0
    };
    this.carts.push(cart);
  }

  // Only create options key if we have options
  const itemKey = selectedOptions 
    ? `${product.id}-${JSON.stringify(selectedOptions)}` 
    : product.id;
  
  // Find existing item, considering options if they exist
  const existingItem = selectedOptions 
    ? cart.items.find(item => 
        item.id === product.id && 
        JSON.stringify(item.selectedOptions) === JSON.stringify(selectedOptions)
      )
    : cart.items.find(item => item.id === product.id && !item.selectedOptions);

  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    const newItem = { 
      ...product, 
      quantity: 1,
      itemKey,
    };

    // Only add options-related properties if we have options
    if (selectedOptions) {
      newItem.selectedOptions = selectedOptions;
      newItem.finalPrice = selectedOptions.totalPrice;
    }

    cart.items.push(newItem);
  }
  
  this.updateCartTotal(venueId);
},

updateCartTotal(venueId) {
  const cart = this.carts.find(c => c.venueId === venueId);
  if (cart) {
    cart.total = cart.items.reduce((total, item) => {
      const itemPrice = item.finalPrice || item.price;
      return total + (itemPrice * item.quantity);
    }, 0);
    
    cart.tax = cart.items.reduce((tax, item) => {
      const itemPrice = item.finalPrice || item.price;
      return tax + (itemPrice * item.quantity * (item.charm.taxrate || 0));
    }, 0);
    
    if (cart.items.length === 0) {
      const index = this.carts.findIndex(c => c.venueId === venueId);
      this.carts.splice(index, 1);
    }
    
    this.saveCartsToLocal();
  }
},

getAllCartsTotal() {
  return this.carts.reduce((total, cart) => 
    total + cart.total + cart.tax, 0);
},

updateQuantity(itemKey, quantity, venueId) {
  const cart = this.carts.find(c => c.venueId === venueId);
  if (!cart) return;
  
  // Find item by itemKey or id if itemKey doesn't exist
  const item = cart.items.find(item => 
    (item.itemKey || item.id) === itemKey
  );

  if (item) {
    item.quantity = Math.max(0, quantity);
    if (item.quantity === 0) {
      this.removeFromCart(itemKey, venueId);
    }
    this.updateCartTotal(venueId);
  }
},

removeFromCart(itemKey, venueId) {
  const cart = this.carts.find(c => c.venueId === venueId);
  if (cart) {
    // Filter using either itemKey or id
    cart.items = cart.items.filter(item => 
      (item.itemKey || item.id) !== itemKey
    );
    this.updateCartTotal(venueId);
  }
},

 clearCart(venueId) {
   const cartIndex = this.carts.findIndex(c => c.venueId === venueId);
   if (cartIndex > -1) {
     this.carts.splice(cartIndex, 1);
     this.saveCartsToLocal();
   }
 },

 clearAllCarts() {
   this.carts = [];
   this.saveCartsToLocal();
 },


 saveCartsToLocal() {
   localStorage.setItem('carts', JSON.stringify(this.carts));
 },

 loadCartsFromLocal() {
   this.carts = JSON.parse(localStorage.getItem('carts') || '[]');
 },

 // Helper methods
 getCart(venueId) {
   return this.carts.find(c => c.venueId === venueId) || null;
 },

 getCartTotal(venueId) {
   const cart = this.getCart(venueId);
   return cart ? cart.total : 0;
 },

 getCartItemCount(venueId) {
   const cart = this.getCart(venueId);
   return cart ? cart.items.reduce((count, item) => count + item.quantity, 0) : 0;
 }
});

// Initialize the store
store.init();

export default store;

